var activeModals = [];
export function addModal(modalInstance) {
  activeModals.push(modalInstance);
}
export function removeModal(modalInstance) {
  var idx = findModalIndex(modalInstance);
  if (idx !== -1) {
    activeModals.splice(idx, 1);
  }
}
export function isTopModal(modalInstance) {
  var idx = findModalIndex(modalInstance);
  return idx === activeModals.length - 1;
}
function findModalIndex(modalInstance) {
  return activeModals.indexOf(modalInstance);
}